import maintainerApi from 'api/maintainerApi';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';

DialogCreateMaintainerReconciliation.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogCreateMaintainerReconciliation({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedMaintainer, setSelectedMaintainer] = useState();
    const [month, setMonth] = useState('');
    useEffect(() => {
        if (item) {
            setSelectedMaintainer({
                id: item?.agencyId,
                name: item?.agency?.name,
                email: item?.agency?.email,
                item: item?.agency,
            });
            setMonth(item?.month);
        }
    }, [item]);

    const dropdownMaintainerEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="maintainer"
                toggleElement={({ showError }) => (
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                            ${showError ? 'border-invalid' : ''}
                            ${!!item ? 'disabled' : ''}
                            `}
                        type="button"
                    >
                        {selectedMaintainer?.id ? selectedMaintainer?.name ?? 'Tất cả' : 'Chọn kỹ thuật viên'}
                    </button>
                )}
                selectedValue={selectedMaintainer}
                dropdownMenuItems={[]}
                getSubItems={async (item) => {
                    try {
                        const currentPage = item?.page || 0;
                        return await maintainerApi.getMaintainerList(
                            Utils.filterParams({
                                role: item?.role,
                                page: currentPage,
                                limit: 10,
                                q: item?.q || '',
                                status: 'NORMAL',
                            })
                        ).then((data) => {
                            const values = data.maintainers?.map((maintainer) => ({
                                id: maintainer?.agencyId,
                                name: maintainer?.name,
                                email: maintainer?.email,
                                item: maintainer,
                            }));
                            return {
                                values: currentPage === 0 ? [{ id: 'ALL', name: 'Tất cả', email: '', item: {} }, ...(values || [])] : values || [],
                                total: data.total
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching maintainer list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedMaintainer(value);
                }}
                enableCheckValid={readyToValidate}
                isValid={Utils.isValid(selectedMaintainer)}
                isTouched={readyToValidate}
                isDropdownForm={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{ name: 'Kỹ thuật viên', role: 'MAINTAINER' }}
                titleType='name'
                subTitleType='email'
                ignoreConfirmClick={true}
                idCheckType='id'
                disabled={!!item}
            />
        );
    }, [selectedMaintainer]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(selectedMaintainer) ||
            !Utils.isValid(month)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        let params = {
            agencyId: selectedMaintainer?.id != 'ALL' ? selectedMaintainer?.id?.toString() : '',
            month,
        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');

        console.log({ params });
        setLoading(true);
        const res = await MaintainerHelper.API.requestCreateMaintainerReconciliation(params);
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Tạo lại đối soát thành công');
            onDone && onDone();
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* maintainer */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Kỹ thuật viên', true)}
                    {dropdownMaintainerEl}
                </div>
                {/* month */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Kỳ đối soát', true)}
                    <KTFormInput
                        type={KTFormInputType.month}
                        placeholder="Chọn kỳ đối soát"
                        name="month"
                        value={month}
                        onChange={(value) => {
                            setMonth(value);
                        }}
                        isTouched={readyToValidate}
                        disabled={!!item}
                    />
                </div>
                <div className="col-12 mb-4 px-2" >
                    <div className='p-4'
                        style={{
                            border: `1px solid ${AppColors.danger}`,
                            borderRadius: 10,
                            backgroundColor: '#FFF6F6'
                        }}>
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}>
                            Lưu ý:
                        </div>
                        <div style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                            Sau khi tạo lại đối soát, các dữ liệu của BCĐS có thể thay đổi.
                        </div>
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center gap-3 px-4 py-3 w-100"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                <div className='flex-grow-1'>
                    {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                </div>
                <div className='flex-grow-1'>
                    {UIHelper.buildGreenButton(
                        'Tạo lại',
                        handleSubmit,
                        null,
                        false,
                        loading
                    )}
                </div>
            </div>
        </div>
    );
}

export default DialogCreateMaintainerReconciliation;
